import { PrescribableItemType } from "elephant-web/gql";
import type { MigrationStrategies } from "./_types/migration-strategies";

export const PRESCRIPTION_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  // Null should delete https://rxdb.info/migration-schema.html#providing-strategies
  2: (_) => null,
  3: (oldDoc) => {
    oldDoc.prescribableItemType = PrescribableItemType.ClinicalProduct;
    oldDoc.prescribableItemFreeText = null;
    return oldDoc;
  },
  4: (_) => null,
  5: (_) => null,
  6: (_) => null,
  7: (oldDoc) => oldDoc,
  8: (oldDoc) => oldDoc,
  9: (oldDoc) => oldDoc,
};
